import React, { useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { CalendarDays, Users, TrendingUp, Activity, Store, CreditCard, MapPin } from 'lucide-react';

export const DashboardTab = ({ stats, bookings, transactions, clients, sites, isSuperAdmin, setActiveTab, t }) => {
  const [dashSiteFilter, setDashSiteFilter] = useState('all');

  if (!stats) return null;

  const fb = dashSiteFilter === 'all' ? bookings : bookings.filter(b => b.site_id === dashSiteFilter);
  const ft = dashSiteFilter === 'all' ? transactions : transactions.filter(tx => tx.site_id === dashSiteFilter);
  const fc = dashSiteFilter === 'all' ? clients : clients.filter(c => fb.some(b => b.user_id === c.id || b.client_email === c.email));
  const fStats = {
    total: fb.length,
    confirmed: fb.filter(b => b.status === 'confirmed').length,
    pending: fb.filter(b => b.status === 'pending').length,
    onsite: fb.filter(b => b.status === 'pending_onsite').length,
    clients: dashSiteFilter === 'all' ? clients.length : fc.length,
    revenue: ft.filter(tx => tx.status === 'completed' || tx.status === 'succeeded').reduce((s, tx) => s + (tx.amount || 0), 0),
  };
  const cards = [
    { l: t('admin.stat.bookings'), v: fStats.total, i: CalendarDays, c: '#00FF00', tab: 'bookings' },
    { l: t('admin.stat.confirmed'), v: fStats.confirmed, i: TrendingUp, c: '#00FF00', tab: 'bookings' },
    { l: t('admin.stat.pending'), v: fStats.pending, i: Activity, c: '#F59E0B', tab: 'bookings' },
    { l: t('admin.stat.onsite'), v: fStats.onsite, i: Store, c: '#3B82F6', tab: 'bookings' },
    { l: t('admin.stat.clients'), v: fStats.clients, i: Users, c: '#8B5CF6', tab: 'clients' },
    { l: t('admin.stat.revenue'), v: `${fStats.revenue}€`, i: CreditCard, c: '#00FF00', tab: 'transactions' },
  ];

  return (
    <>
      {isSuperAdmin && sites.length > 1 && (
        <div className="flex items-center gap-3 mb-6">
          <Select value={dashSiteFilter} onValueChange={setDashSiteFilter}>
            <SelectTrigger className="w-56 bg-[#1A1A1A] border-[#2A2A2A] text-white" data-testid="dash-site-filter">
              <MapPin className="w-4 h-4 mr-2 text-[#00FF00]" />
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="bg-[#1A1A1A] border-[#2A2A2A]">
              <SelectItem value="all" className="text-white">{t('admin.all_sites')}</SelectItem>
              {sites.map(s => <SelectItem key={s.id} value={s.id} className="text-white">{s.city}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      )}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-testid="admin-stats">
        {cards.map(s => (
          <button key={s.l} onClick={() => setActiveTab(s.tab)} className="bg-[#1A1A1A] rounded-2xl border border-[#2A2A2A] p-5 text-left hover:border-[#00FF00]/40 transition-colors cursor-pointer" data-testid={`stat-${s.tab}`}>
            <div className="w-9 h-9 rounded-lg flex items-center justify-center mb-3" style={{ backgroundColor: `${s.c}15` }}><s.i className="w-5 h-5" style={{ color: s.c }} /></div>
            <p className="font-heading text-2xl font-bold text-white">{s.v}</p>
            <p className="text-xs text-slate-500 mt-1">{s.l}</p>
          </button>
        ))}
      </div>
    </>
  );
};
